import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';

import { SubsetSuggestionStatus } from '../../../../backend/src/matter/subset/subset-suggestion/subset-suggestion.entity';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useUpdateSuggestionStatus = () => {
  const { matterId } = useParams<{ matterId: string }>();
  const queryClient = useQueryClient();
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation(
    async ({
      suggestionId,
      status,
    }: {
      suggestionId: string;
      status: SubsetSuggestionStatus.Accepted | SubsetSuggestionStatus.Dismissed;
    }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        data: { status },
      });
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/suggestions/${suggestionId}`,
        fetchConfig,
      );
      if (!res.ok) {
        throw new Error('Failed to update suggestion status');
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryEntity.SubsetSuggestions, { matterId }]);
      },
    },
  );
};
